export default __webpack_public_path__ + "static/media/c2.a3b0d25c.svg";